import { render } from "./AuthPasswordReset.vue?vue&type=template&id=dc5f0b26&scoped=true"
import script from "./AuthPasswordReset.vue?vue&type=script&lang=ts"
export * from "./AuthPasswordReset.vue?vue&type=script&lang=ts"

import "./AuthPasswordReset.vue?vue&type=style&index=0&id=dc5f0b26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dc5f0b26"

export default script